import { type ReactNode } from 'react';

// Превращает в тексте все http(s)://... в кликабельные ссылки.
// Ссылки на /api/v1/attachments/<id>/download кликаются через
// onClickAttachment (если передан) — потому что endpoint требует
// JWT-заголовок и обычный <a href> возвращает 401.
export function linkify(
  text: string,
  onClickAttachment?: (id: string) => void,
): ReactNode[] {
  const out: ReactNode[] = [];
  const re = /(https?:\/\/[^\s<>"']+)/g;
  let last = 0;
  let i = 0;
  let m = re.exec(text);
  while (m !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const url = m[1];
    const att = url.match(/\/api\/v1\/attachments\/([\w-]+)\/download/);
    if (att && onClickAttachment) {
      const id = att[1];
      out.push(
        <a key={i++} href="#"
           onClick={(e) => { e.preventDefault(); onClickAttachment(id); }}
           className="text-blue-400 hover:underline break-all">{url}</a>
      );
    } else {
      out.push(
        <a key={i++} href={url} target="_blank" rel="noreferrer"
           className="text-blue-400 hover:underline break-all">{url}</a>
      );
    }
    last = m.index + url.length;
    m = re.exec(text);
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

// Извлечь attachment_id из текста, если в нём есть ссылка на endpoint скачивания.
export function findAttachmentId(text: string): string | null {
  const m = text.match(/\/api\/v1\/attachments\/([\w-]+)\/download/);
  return m ? m[1] : null;
}
